<div class="main-content datos-personales-page">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 col-xl-10">
        <section class="datos-card">
          <div class="datos-card__header">
            <div class="datos-card__title">
              <i class="material-icons">person_outline</i>
              <span>Datos personales</span>
            </div>
          </div>

          <form [formGroup]="formGroupPersona" class="datos-card__body">
            <div class="row datos-grid">
              <div class="col-12 col-md-6">
                <div class="datos-field-wrap">
                  <label class="datos-field-wrap__label" for="nombre">Nombre</label>
                  <mat-form-field appearance="outline" class="datos-field">
                    <mat-icon matPrefix>person_outline</mat-icon>
                    <input id="nombre" matInput maxlength="30" formControlName="controlNombre"
                      soloLetraEspacio autocomplete="off">
                  </mat-form-field>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="datos-field-wrap">
                  <label class="datos-field-wrap__label" for="ampaterno">Apellido paterno</label>
                  <mat-form-field appearance="outline" class="datos-field">
                    <mat-icon matPrefix>badge</mat-icon>
                    <input id="ampaterno" matInput type="text" maxlength="25" formControlName="controlAPaterno"
                      soloLetraEspacio autocomplete="off">
                  </mat-form-field>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="datos-field-wrap">
                  <label class="datos-field-wrap__label" for="amaterno">Apellido materno</label>
                  <mat-form-field appearance="outline" class="datos-field">
                    <mat-icon matPrefix>badge</mat-icon>
                    <input id="amaterno" matInput type="text" maxlength="25" formControlName="controlAMaterno"
                      soloLetraEspacio autocomplete="off"
                      oninput="this.value = this.value.trim()">
                  </mat-form-field>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="datos-field-wrap">
                  <label class="datos-field-wrap__label" for="email">Correo electrónico</label>
                  <mat-form-field appearance="outline" class="datos-field">
                    <mat-icon matPrefix>mail_outline</mat-icon>
                    <input id="email" matInput type="email" maxlength="60" formControlName="controlEmail"
                      pattern="^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$"
                      autocomplete="off" oninput="this.value = this.value.trim()">
                  </mat-form-field>
                </div>
              </div>
            </div>



            <div class="datos-card__actions">
              <button type="button" mat-raised-button class="btn datos-btn datos-btn--secondary" (click)="cancelar()">
                Cancelar
              </button>

              <button type="button" mat-raised-button class="btn datos-btn datos-btn--primary"
                (click)="guardaDatosUsuario()">
                Guardar cambios
              </button>
            </div>
          </form>
        </section>

        <section class="datos-support">
          <div class="datos-support__icon">
            <i class="material-icons">info_outline</i>
          </div>

          <div class="datos-support__copy">
            <strong>¿Necesitas ayuda con tu cuenta?</strong>
            <span>Si tienes problemas para actualizar tus datos, contacta al departamento de Sistemas.</span>
          </div>

          <div class="datos-support__cta">Soporte Técnico</div>
        </section>
      </div>
    </div>
  </div>
</div>
